import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'date', sortDesc = false, fetchFacets = true) {

    return Api().post('/negotiators/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  commissions(data) {
    return Api().get('/negotiator/' + data.nego_id + '/commissions');
  },
  connectKeycloak(id) {
    return Api().get('/negotiator/' + id + '/keycloak-connect');
  },
  get(id) {
    return Api().get('/negotiator/keycloak/' + id);
  },
  update(id, data) {
    return Api().post('/negotiator/' + id, qs.stringify({ data: JSON.stringify(data)}));
  },
  set_nego(locality) {
    return Api().get('/negotiator/locality/' + locality);
  },
  alert_nego(mandatID) {
    return Api().post('/negotiator/alert/warrant/' + mandatID);
  },
  history(data) {
    return Api().post('/negotiator/history', qs.stringify({ data: JSON.stringify(data)}));
  },
  delete_negotiator(data) {
    return Api().delete('/negotiator/' + data.negotiator_id );
  },
  update_negotiator(data) {
    return Api().post('/negotiator/' + data.negotiator_id , qs.stringify({ data: JSON.stringify(data.negotiator) }));    
  },
  create_negotiator(data) {
    return Api().post('/negotiator/' + data.negotiator_id, qs.stringify({ data: JSON.stringify(data.negotiator) }));    
  },
  negotiator(data) {
    return Api().get('/negotiator/' + data.negotiator_id );
  }
}